import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Modal, Button } from '@airasia/phoenix-components/components';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import { useWindowSize } from '../../utils';

const CheckoutAnimationWrapper = styled.div`
  background-image: url(${props => props.animation});
  background-repeat: no-repeat;
  background-position: center;
  width: 232px;
  height: 153px;
  background-size: contain;
  margin: 0 auto 16px;
`;

const ModalContentWrapper = styled(Wrapper)`
  max-height: 70vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingTop: '24px',
  paddingBottom: '24px',
`;

const ButtonWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  gap: 16px;
  margin-top: 16px;
`;

const StyledButton = styled(Button)`
  width: 280px;
  max-width: calc(100% - 32px);
`;

const TextWrapper = styled(Wrapper)`
  margin-top: 6px;
  margin-bottom: 24px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const TitleText = styled(Text)`
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: black;
  margin-bottom: 4px;
`;

const DescriptionText = styled(Text)`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: #4c4c50;
  margin-top: 6px;
  margin-bottom: ${({ secondaryClick }) => (!secondaryClick ? '-16px' : '0')};
`;

const FeedbackModal = ({
  isVisible,
  precheckoutData,
  secondaryClick,
  primaryClick,
}) => {
  const { isMobileView } = useWindowSize();

  if (isEmpty(precheckoutData)) {
    return null;
  }

  return (
    <Modal
      openModal={isVisible}
      modalCenter
      width={isMobileView ? '90%' : '400px'}
      backgroundColor="default"
      overlayBackgroundColor="black"
      showCloseIcon={false}
      zIndex={9999}
      overlayOpacity="0.8"
    >
      <ModalContentWrapper>
        <CheckoutAnimationWrapper animation={precheckoutData.image} />

        <TextWrapper>
          <TitleText>{get(precheckoutData, 'title', '')}</TitleText>
          {!isEmpty(precheckoutData.descriptions) &&
            precheckoutData.descriptions.map((description, index) => (
              <DescriptionText
                key={index}
                secondaryClick={precheckoutData.secondaryButton}
              >
                {description}
              </DescriptionText>
            ))}
        </TextWrapper>

        <ButtonWrapper>
          {!isEmpty(precheckoutData.secondaryButton) && (
            <StyledButton
              color="secondary"
              border="secondary"
              handleClick={secondaryClick}
            >
              {get(precheckoutData, 'secondaryButton', '')}
            </StyledButton>
          )}
          {!isEmpty(precheckoutData.primaryButton) && (
            <StyledButton
              backgroundColor="primary"
              color="secondary"
              border="secondary"
              handleClick={primaryClick}
            >
              <Text fontWeight={500} lineHeight="24px">
                {get(precheckoutData, 'primaryButton', '')}
              </Text>
            </StyledButton>
          )}
        </ButtonWrapper>
      </ModalContentWrapper>
    </Modal>
  );
};

FeedbackModal.propTypes = {
  isVisible: PropTypes.bool.isRequired, // Adjust `isRequired` based on your logic
  precheckoutData: PropTypes.shape({
    image: PropTypes.string,
    descriptions: PropTypes.arrayOf(PropTypes.string),
    secondaryButton: PropTypes.string,
    primaryButton: PropTypes.string,
  }).isRequired, // Adjust `isRequired` based on your logic
  secondaryClick: PropTypes.func.isRequired,
  primaryClick: PropTypes.func.isRequired,
};

export default FeedbackModal;
